import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
interface HeroSectionProps {
  onScrollToPurchase: () => void;
}
export function HeroSection({
  onScrollToPurchase
}: HeroSectionProps) {
  return <section className="relative overflow-hidden bg-[#fafaf9] pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-42">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-43">
            <span className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-[#2d5016] bg-[#e8f5e9] rounded-full" data-id="element-44">
              Más de 1.578 personas ya multiplicaron sus plantas con esta guía
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1a1a1a] leading-tight mb-6" data-id="element-45">
              Multiplicá tus plantas sin perderlas en el intento
            </h1>

            <p className="text-xl md:text-2xl text-[#4a7c2c] font-medium mb-8 leading-relaxed" data-id="element-46">
              La guía paso a paso que te muestra exactamente qué hacer en cada
              etapa para que tus esquejes enraícen y crezcan, sin dudas ni
              prueba y error
            </p>

            {/* Trust indicators */}
            <div className="bg-white border border-[#e8f5e9] rounded-2xl p-4 mb-8 shadow-sm" data-id="element-47">
              <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-48">
                <div className="flex items-start gap-2" data-id="element-49">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-50" />
                  <span className="text-[#666666]" data-id="element-51">
                    Ideal para principiantes
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-52">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-53" />
                  <span className="text-[#666666]" data-id="element-54">Acceso inmediato</span>
                </div>
                <div className="flex items-start gap-2" data-id="element-55">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-56" />
                  <span className="text-[#666666]" data-id="element-57">Método probado</span>
                </div>
                <div className="flex items-start gap-2" data-id="element-58">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-59" />
                  <span className="text-[#666666]" data-id="element-60">Sin experiencia previa</span>
                </div>
              </div>
            </div>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={onScrollToPurchase} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-[#4a7c2c] rounded-full shadow-lg hover:bg-[#3d6624] transition-colors w-full md:w-auto" data-id="element-61">
              Empezar a multiplicar mis plantas
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-62" />
            </motion.button>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full" data-id="element-63">
            <div className="relative cursor-pointer group" onClick={onScrollToPurchase} data-id="element-64">
              <div className="absolute inset-0 bg-[#4a7c2c] rounded-2xl opacity-0 group-hover:opacity-10 transition-opacity duration-300 blur-xl" data-id="element-65"></div>
              <img src="https://cdn.magicpatterns.com/uploads/h45ZLkfyEb6KobfDUcdtpV/ChatGPT_Image_19_ene_2026,_03_20_12.png" alt="Guía Para Hacer Esquejes - Portada del Libro" className="relative w-full h-auto drop-shadow-2xl transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-66" />
            </div>

            {/* Text below image */}
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="mt-6 text-center text-lg text-[#666666] leading-relaxed" data-id="element-67">
              Todo organizado en un solo lugar, sin buscar videos sueltos ni
              improvisar. Seguís pasos claros y obtenés resultados.
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>;
}